let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bjwj6")).then(() => parcelRequire('hiP1C'));